import {
  Stages,
  Services,
  StageAuthRetrievalUrlsMap,
  Audiences,
  ServiceSubdomainMap,
  StageDomainNameMap,
  HostnameStageMap,
  ServiceLocalPortMap,
  ServiceBasePathMap,
  AudienceOptionsMap,
} from './constants'

export function getService() {
  const pageUrl = new URL(window.location.href)

  const service = pageUrl.searchParams.get('service')

  if (service && Object.values(Services).includes(service)) {
    return service
  }

  return Services.CONTENT
}

export function getAppStage() {
  const pageUrl = new URL(window.location.href)

  const searchParamsStage = pageUrl.searchParams.get('stage')
  if (searchParamsStage && Object.values(Stages).includes(searchParamsStage)) {
    return searchParamsStage
  }

  return HostnameStageMap[pageUrl.hostname]
}

export function getAudience() {
  const pageUrl = new URL(window.location.href)

  const audience = pageUrl.searchParams.get('audience')

  if (audience && Object.values(Audiences).includes(audience)) {
    return audience
  }

  const service = getService()

  return AudienceOptionsMap[service]?.[0] ?? Audiences.ADMIN
}

function getBaseUrl({ service, audience, stage }) {
  if (stage === Stages.LOCAL) {
    return `http://localhost:${ServiceLocalPortMap[service]}/v1/${audience}`
  }

  return `https://${ServiceSubdomainMap[service]?.[audience] ?? 'api'}.${StageDomainNameMap[stage]}/${ServiceBasePathMap[service]}/${audience}`
}

export function getOpenApiUrl({ service, audience, stage }) {
  return `${getBaseUrl({ service, audience, stage })}/apidocs/openapi.json`
}

export function getPostmanCollectionUrl({ service, audience, stage }) {
  return `${getBaseUrl({ service, audience, stage })}/apidocs/postman-collection.json`
}

export function getStaticDocsUrl({ service, audience, stage }) {
  return `${getBaseUrl({ service, audience, stage })}/apidocs/static`
}

function getUpdatedUrl({ service, audience, stage }) {
  const url = new URL(window.location.href)

  if (service) {
    url.searchParams.set('service', service)
  }

  if (audience) {
    url.searchParams.set('audience', audience)
  }

  if (stage) {
    url.searchParams.set('stage', stage)
  }

  return url.href
}

export function setUrl({ service, audience, stage }) {
  window.history.pushState({}, '', getUpdatedUrl({ service, audience, stage }))
}

export function getAuthToken({ username, password, loginUrl, stage }) {
  return new Promise((resolve, reject) => {
    if (loginUrl && username && password) {
      fetch(StageAuthRetrievalUrlsMap[stage], {
        method: 'POST',
        body: JSON.stringify({ username, password, loginUrl }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.json())
        .then((data) => resolve(data.accessToken))
        .catch(reject)
    } else {
      reject(new Error('Missing required parameters'))
    }
  })
}
